<template>
	<v-card outlined>
		<v-card-text v-if="users">
			<v-simple-table dense height="300px">
				<template v-slot:default>
					<thead>
						<tr>
							<th class="text-left minwidthtabla">
								Creado
							</th>
							<th class="text-left">
								Nombre
							</th>
							<th class="text-left">
								Apellido
							</th>
							<th class="text-left">
								Celular
							</th>
							<th class="text-left">
								Correo
							</th>

							<th class="text-left">
								Compañia
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="user in users" :key="user._id">
							<td class="text-left">
								{{ getCreated(user._id) }}
							</td>
							<td class="text-left">{{ user.name }}</td>
							<td class="text-left">{{ user.lastName }}</td>
							<td class="text-left">{{ user.phone }}</td>
							<td class="text-left">{{ user.email }}</td>
							<td class="text-left">{{ user.company }}</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-card-text>
	</v-card>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters({
			users: 'User/users',
		}),
	},
	methods: {
		getCreated(id) {
			const createAt = new Date(parseInt(id.toString().slice(0, 8), 16) * 1000);
			return moment(createAt).format('lll');
		},
	},
};
</script>

<style lang="scss" scoped></style>
